import { Chart } from "react-charts";
import React from "react";
import { ResizableBox as ReactResizableBox } from "react-resizable";

export default function AUC() {
    const data = React.useMemo(
        () => [
          {
            label: "AUC Training",
            data: [
              { primary: "Boost", secondary: 0.882171228260308},
              { primary: "Decision Tree", secondary: 0.8821493393873973},
              { primary: "NB", secondary: 0.8823094939922775},
              { primary: "SGD", secondary: 0.8829262846468514},
              { primary: "SVM", secondary: 0.882089884477242},
            ],
          }, {
            label: "AUC Testing",
            data: [
              { primary: "Boost", secondary: 0.8516585875851042},
              { primary: "Decision Tree", secondary: 0.8514692282376656},
              { primary: "NB", secondary: 0.8528268495613647},
              { primary: "SGD", secondary: 0.8532223846283277},
              { primary: "SVM", secondary: 0.8567114773395975},
            ],
          }, 
        ],
        []
      );
      const axes = React.useMemo(
        () => [
          { primary: true, type: 'ordinal', position: 'bottom' },
          { type: 'linear', position: 'left' },
        ], []
      );
      return (
        <ReactResizableBox width={500} height={300} style={{textAlign: "center"}}>
					<strong>AUC</strong>
          <Chart data={data} axes={axes} tooltip/>
        </ReactResizableBox>
      );
};